// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"46bfc4b0","402":"0d654046","647":"1d374419","757":"99e9554d","769":"c0952a86","771":"b4a2aaca","774":"cb4c72ff","793":"996bfb2a","956":"22b3dce7","957":"5f91b68a"}[chunkId] + ".chunk.js";
};